import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CalendarsTemplate } from 'components/Templates'

const Calendars: FC = () => {
  return (
    <Layout headline={'祝日の設定'} title={'祝日の設定'}>
      <CalendarsTemplate />
    </Layout>
  )
}

export default Calendars
